export const enum SupportChatAvailabilityStatus {
    OnSale = 0,
    SoldOut = 1,
    SaleEnded = 2,
    SaleNotStarted = 3,
    NoOnlineSale = 4,
    EventEnded = 5,
    NotFound = 6
}
